import { Directive, forwardRef, Attribute } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[requiredIf][formControlName]',
  providers: [
      { provide: NG_VALIDATORS, useExisting: forwardRef(() => RequiredIfDirective), multi: true }
  ]
})
export class RequiredIfDirective {
    constructor(@Attribute('requiredIf') public requiredFieldName: string) {}
    
    validate(c: AbstractControl): { [key: string]: any } {
        let e = c.root.get(this.requiredFieldName);
        if (e && e.value && !c.value) return {
            requiredIf: false
        }
        return null;
    }
}